/*
  pages.js — runtime for the footer/pages surface: facets + sort (search & collection), the search
  template's <main-search>, <show-more-button>, the /cart page (<cart-items>, <cart-remove-button>),
  <contact-form> validation and the <splide-component> mobile slider used by "You may also like".
  Relies on global.js: debounce, onKeyUpEscape, fetchConfig, PUB_SUB_EVENTS, publish/subscribe,
  <quantity-input>, <menu-drawer>. Guarded so it is safe to load from several sections at once.
*/
(function () {
  if (window.__hcPagesLoaded) return;
  window.__hcPagesLoaded = true;

  if (typeof window.ON_CHANGE_DEBOUNCE_TIMER === 'undefined') window.ON_CHANGE_DEBOUNCE_TIMER = 300;
  var ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER;

  /* ---------------------------------------------------------------- facets (Dawn, MIT) */
class FacetFiltersForm extends HTMLElement{constructor(){super(),this.onActiveFilterClick=this.onActiveFilterClick.bind(this),this.debouncedOnSubmit=debounce(event=>{this.onSubmitHandler(event)},500),this.querySelector("form").addEventListener("input",this.debouncedOnSubmit.bind(this));const facetWrapper=this.querySelector("#FacetsWrapperDesktop");facetWrapper&&facetWrapper.addEventListener("keyup",onKeyUpEscape)}static setListeners(){const onHistoryChange=event=>{const searchParams=event.state?event.state.searchParams:FacetFiltersForm.searchParamsInitial;searchParams!==FacetFiltersForm.searchParamsPrev&&FacetFiltersForm.renderPage(searchParams,null,!1)};window.addEventListener("popstate",onHistoryChange)}static toggleActiveFacets(disable=!0){document.querySelectorAll(".js-facet-remove").forEach(element=>{element.classList.toggle("disabled",disable)})}static renderPage(searchParams,event,updateURLHash=!0){FacetFiltersForm.searchParamsPrev=searchParams;const sections=FacetFiltersForm.getSections(),countContainer=document.getElementById("ProductCount"),countContainerDesktop=document.getElementById("ProductCountDesktop");document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"),countContainer&&countContainer.classList.add("loading"),countContainerDesktop&&countContainerDesktop.classList.add("loading"),sections.forEach(section=>{const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`,filterDataUrl=element=>element.url===url;FacetFiltersForm.filterData.some(filterDataUrl)?FacetFiltersForm.renderSectionFromCache(filterDataUrl,event):FacetFiltersForm.renderSectionFromFetch(url,event)}),updateURLHash&&FacetFiltersForm.updateURLHash(searchParams)}static renderSectionFromFetch(url,event){fetch(url).then(response=>response.text()).then(responseText=>{const html=responseText;FacetFiltersForm.filterData=[...FacetFiltersForm.filterData,{html,url}],FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html)})}static renderSectionFromCache(filterDataUrl,event){const html=FacetFiltersForm.filterData.find(filterDataUrl).html;FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html)}static renderProductGridContainer(html){document.getElementById("ProductGridContainer").innerHTML=new DOMParser().parseFromString(html,"text/html").getElementById("ProductGridContainer").innerHTML}static renderProductCount(html){const count=new DOMParser().parseFromString(html,"text/html").getElementById("ProductCount").innerHTML,container=document.getElementById("ProductCount"),containerDesktop=document.getElementById("ProductCountDesktop");container.innerHTML=count,container.classList.remove("loading"),containerDesktop&&(containerDesktop.innerHTML=count,containerDesktop.classList.remove("loading"))}static renderFilters(html,event){const parsedHTML=new DOMParser().parseFromString(html,"text/html"),facetDetailsElements=parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),matchesIndex=element=>{const jsFilter=event?event.target.closest(".js-filter"):void 0;return jsFilter?element.dataset.index===jsFilter.dataset.index:!1},facetsToRender=Array.from(facetDetailsElements).filter(element=>!matchesIndex(element)),countsToRender=Array.from(facetDetailsElements).find(matchesIndex);facetsToRender.forEach(element=>{document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML=element.innerHTML}),FacetFiltersForm.renderActiveFacets(parsedHTML),FacetFiltersForm.renderAdditionalElements(parsedHTML),countsToRender&&FacetFiltersForm.renderCounts(countsToRender,event.target.closest(".js-filter"))}static renderActiveFacets(html){[".active-facets-mobile",".active-facets-desktop"].forEach(selector=>{const activeFacetsElement=html.querySelector(selector);activeFacetsElement&&(document.querySelector(selector).innerHTML=activeFacetsElement.innerHTML)}),FacetFiltersForm.toggleActiveFacets(!1)}static renderAdditionalElements(html){[".mobile-facets__open",".mobile-facets__count",".sorting"].forEach(selector=>{html.querySelector(selector)&&(document.querySelector(selector).innerHTML=html.querySelector(selector).innerHTML)}),document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()}static renderCounts(source,target){const targetElement=target.querySelector(".facets__selected"),sourceElement=source.querySelector(".facets__selected"),targetElementAccessibility=target.querySelector(".facets__summary"),sourceElementAccessibility=source.querySelector(".facets__summary");sourceElement&&targetElement&&(target.querySelector(".facets__selected").outerHTML=source.querySelector(".facets__selected").outerHTML),targetElementAccessibility&&sourceElementAccessibility&&(target.querySelector(".facets__summary").outerHTML=source.querySelector(".facets__summary").outerHTML)}static updateURLHash(searchParams){history.pushState({searchParams},"",`${window.location.pathname}${searchParams&&"?".concat(searchParams)}`)}static getSections(){return[{section:document.getElementById("product-grid").dataset.id}]}createSearchParams(form){const formData=new FormData(form);return new URLSearchParams(formData).toString()}onSubmitForm(searchParams,event){FacetFiltersForm.renderPage(searchParams,event)}onSubmitHandler(event){event.preventDefault();const sortFilterForms=document.querySelectorAll("facet-filters-form form");if(event.srcElement.className=="mobile-facets__checkbox"){const searchParams=this.createSearchParams(event.target.closest("form"));this.onSubmitForm(searchParams,event)}else{const forms=[],isMobile=event.target.closest("form").id==="FacetFiltersFormMobile";sortFilterForms.forEach(form=>{isMobile?form.id==="FacetFiltersFormMobile"&&forms.push(this.createSearchParams(form)):(form.id==="FacetSortForm"||form.id==="FacetFiltersForm"||form.id==="FacetSortDrawerForm")&&(document.querySelectorAll(".no-js-list").forEach(el=>el.remove()),forms.push(this.createSearchParams(form)))}),this.onSubmitForm(forms.join("&"),event)}}onActiveFilterClick(event){event.preventDefault(),FacetFiltersForm.toggleActiveFacets();const url=event.currentTarget.href.indexOf("?")==-1?"":event.currentTarget.href.slice(event.currentTarget.href.indexOf("?")+1);FacetFiltersForm.renderPage(url)}}FacetFiltersForm.filterData=[],FacetFiltersForm.searchParamsInitial=window.location.search.slice(1),FacetFiltersForm.searchParamsPrev=window.location.search.slice(1);if(!customElements.get("facet-filters-form")){customElements.define("facet-filters-form",FacetFiltersForm);FacetFiltersForm.setListeners();}class PriceRange extends HTMLElement{constructor(){super(),this.querySelectorAll("input").forEach(element=>element.addEventListener("change",this.onRangeChange.bind(this))),this.setMinAndMaxValues()}onRangeChange(event){this.adjustToValidValues(event.currentTarget),this.setMinAndMaxValues()}setMinAndMaxValues(){const inputs=this.querySelectorAll("input"),minInput=inputs[0],maxInput=inputs[1];maxInput.value&&minInput.setAttribute("max",maxInput.value),minInput.value&&maxInput.setAttribute("min",minInput.value),minInput.value===""&&maxInput.setAttribute("min",0),maxInput.value===""&&minInput.setAttribute("max",maxInput.getAttribute("max"))}adjustToValidValues(input){const value=Number(input.value),min=Number(input.getAttribute("min")),max=Number(input.getAttribute("max"));value<min&&(input.value=min),value>max&&(input.value=max)}}if(!customElements.get("price-range"))customElements.define("price-range",PriceRange);class FacetRemove extends HTMLElement{constructor(){super();const facetLink=this.querySelector("a");facetLink.setAttribute("role","button"),facetLink.addEventListener("click",this.closeFilter.bind(this)),facetLink.addEventListener("keyup",event=>{event.preventDefault(),event.code.toUpperCase()==="SPACE"&&this.closeFilter(event)})}closeFilter(event){event.preventDefault(),(this.closest("facet-filters-form")||document.querySelector("facet-filters-form")).onActiveFilterClick(event)}}if(!customElements.get("facet-remove"))customElements.define("facet-remove",FacetRemove);



  /* ---------------------------------------------------------------- search template */
  class SearchFormBase extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener('input', debounce((event) => { this.onChange(event); }, 300).bind(this));
      }
    }
    toggleResetButton() {
      if (!this.resetButton) return;
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) this.resetButton.classList.remove('hidden');
      else if (this.input.value.length === 0 && !resetIsHidden) this.resetButton.classList.add('hidden');
    }
    onChange() { this.toggleResetButton(); }
    shouldResetForm() { return !document.querySelector('[aria-selected="true"] a'); }
    onFormReset(event) {
      event.preventDefault();
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }

  class MainSearch extends SearchFormBase {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
    }
    setupEventListeners() {
      const allSearchForms = [];
      this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
      if (this.input) this.input.addEventListener('focus', this.onInputFocus.bind(this));
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }
    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) this.keepInSync('', this.input);
    }
    onInput(event) { this.keepInSync(event.target.value, event.target); }
    onInputFocus() { if (window.innerWidth < 750) this.scrollIntoView({ behavior: 'smooth' }); }
    keepInSync(value, target) {
      this.allSearchInputs.forEach((input) => { if (input !== target) input.value = value; });
    }
  }
  if (!customElements.get('main-search')) customElements.define('main-search', MainSearch);

  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
          nextElementToFocus.querySelector('input').focus();
        }
      });
    }
    expandShowMore(event) {
      const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
      this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
      parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
    }
  }
  if (!customElements.get('show-more-button')) customElements.define('show-more-button', ShowMoreButton);

  /* ---------------------------------------------------------------- /cart page */
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        if (cartItems && typeof cartItems.updateQuantity === 'function') cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  if (!customElements.get('cart-remove-button')) customElements.define('cart-remove-button', CartRemoveButton);

  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      const debouncedOnChange = debounce((event) => { this.onChange(event); }, ON_CHANGE_DEBOUNCE_TIMER);
      this.addEventListener('change', debouncedOnChange.bind(this));
    }
    connectedCallback() {
      if (typeof subscribe !== 'function') return;
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') return;
        this.onCartUpdate();
      });
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }
    onChange(event) {
      if (!event.target.dataset.index) return;
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
    onCartUpdate() {
      const sectionId = document.getElementById('main-cart-items').dataset.id;
      fetch(`${routes.cart_url}?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
          const footer = html.querySelector('#main-cart-footer');
          const currentFooter = document.getElementById('main-cart-footer');
          if (footer && currentFooter) currentFooter.classList.toggle('is-empty', footer.classList.contains('is-empty'));
        })
        .catch((e) => { console.error(e); });
    }
    getSectionsToRender() {
      return [
        { id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents' },
      ];
    }
    updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
          if (parsedState.errors) {
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container || !parsedState.sections || !parsedState.sections[section.section]) return;
            const elementToReplace = container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') message = window.cartStrings.error;
            else message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
          this.updateLiveRegions(line, message);
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          else if (parsedState.item_count === 0) {
            const empty = this.querySelector('.cart__empty-text');
            if (empty) empty.focus();
          }
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          }
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        })
        .finally(() => { this.disableLoading(line); });
    }
    updateLiveRegions(line, message) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);
      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      if (cartStatus) {
        cartStatus.setAttribute('aria-hidden', false);
        setTimeout(() => { cartStatus.setAttribute('aria-hidden', true); }, 1000);
      }
    }
    getSectionInnerHTML(html, selector) {
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : '';
    }
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      cartItemElements.forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  /* ---------------------------------------------------------------- contact form */
  class ContactForm extends HTMLElement {
    constructor() {
      super();
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleFieldInput = this.handleFieldInput.bind(this);
    }
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.requiredFields = Array.from(this.querySelectorAll('.field-wrapper[data-required="true"]'));
      if (this.requiredFields.length === 0) return;
      this.form.addEventListener('submit', this.handleFormSubmit);
      this.requiredFields.forEach((wrapper) => {
        const input = wrapper.querySelector('.field__input, .text-area');
        if (input) input.addEventListener('input', this.handleFieldInput);
      });
    }
    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.handleFormSubmit);
      (this.requiredFields || []).forEach((wrapper) => {
        const input = wrapper.querySelector('.field__input, .text-area');
        if (input) input.removeEventListener('input', this.handleFieldInput);
      });
    }
    handleFormSubmit(event) {
      let valid = true;
      this.requiredFields.forEach((wrapper) => {
        const input = wrapper.querySelector('.field__input, .text-area');
        const error = wrapper.querySelector('.field-wrapper__error-msg');
        if (input && !input.value.trim()) {
          valid = false;
          wrapper.classList.add('field-wrapper--error');
          if (error) error.classList.remove('hidden');
        }
      });
      if (!valid) event.preventDefault();
    }
    handleFieldInput(event) {
      const wrapper = event.target.closest('.field-wrapper');
      if (!wrapper) return;
      wrapper.classList.remove('field-wrapper--error');
      const error = wrapper.querySelector('.field-wrapper__error-msg');
      if (error) error.classList.add('hidden');
    }
  }
  if (!customElements.get('contact-form')) customElements.define('contact-form', ContactForm);

  /* ---------------------------------------------------------------- splide slider wrapper */
  /* Reads the same data-* options the served <splide-component> carries. Splide itself is loaded on
     demand (only when a breakpoint actually needs a slider); base.css already ships the Splide CSS. */
  class SplideComponent extends HTMLElement {
    constructor() {
      super();
      this.sliderContainer = this.querySelector('.splide');
      this.onResize = debounce(() => this.initSlider(), 150);
      document.addEventListener('shopify:section:load', () => this.initSlider());
    }
    connectedCallback() {
      this.initSlider();
      window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.splide) { this.splide.destroy(true); this.splide = null; }
    }
    readOptions() {
      const d = this.dataset;
      const num = (v, fallback) => (v !== undefined && !isNaN(parseInt(v)) ? parseInt(v) : fallback);
      const isDesktop = window.innerWidth >= 750;
      return {
        isDesktop,
        destroy: isDesktop ? d.destroyDesktop === 'true' : d.destroyMobile === 'true',
        type: (isDesktop ? d.type : d.typeMobile || d.type) || 'slide',
        rewind: d.type === 'fade',
        autoplay: d.autoplay === 'true',
        interval: num(d.autoplaySpeed, 5) * 1000,
        drag: d.drag === 'false' ? false : d.drag === 'free' ? 'free' : true,
        arrows: d.arrows !== 'false',
        pagination: d.pagination !== 'false',
        perPage: isDesktop ? num(d.slidesDesktop, 3) : num(d.slidesMobile, 1),
        perMove: isDesktop ? num(d.perMoveDesktop, 1) : num(d.perMoveMobile, 1),
        gap: isDesktop ? num(d.gapDesktop, 30) : num(d.gapMobile, 15),
        padding: isDesktop
          ? { left: d.paddingCalcDesktop === 'true' ? 0 : num(d.sidePaddingDesktop, 0), right: num(d.sidePaddingDesktop, 0) }
          : { left: d.paddingCalcMobile === 'true' ? 0 : num(d.sidePaddingMobile, 0), right: num(d.sidePaddingMobile, 0) },
        arrowsColor: d.arrowsColor ? ' color-' + d.arrowsColor : '',
        dotsColor: d.dotsColor ? ' color-' + d.dotsColor + ' dots-custom-color' : '',
      };
    }
    initSlider() {
      if (!this.sliderContainer) return;
      const options = this.readOptions();
      if (options.destroy) {
        if (this.splide) { this.splide.destroy(true); this.splide = null; }
        return;
      }
      this.loadSplide().then(() => {
        if (!window.Splide) return;
        if (this.splide) { this.splide.destroy(true); this.splide = null; }
        const arrows = this.sliderContainer.querySelector('.splide__arrows');
        const dots = this.sliderContainer.querySelector('.splide__pagination');
        if (arrows) arrows.className = 'splide__arrows' + options.arrowsColor;
        if (dots) dots.className = 'splide__pagination' + options.dotsColor;
        this.splide = new window.Splide(this.sliderContainer, {
          type: options.type,
          rewind: options.rewind,
          autoplay: options.autoplay,
          interval: options.interval,
          drag: options.drag,
          arrows: options.arrows,
          pagination: options.pagination,
          perPage: options.perPage,
          perMove: options.perMove,
          gap: options.gap,
          padding: options.padding,
          omitEnd: true,
          mediaQuery: 'min',
        });
        this.splide.mount();
      });
    }
    loadSplide() {
      if (window.Splide) return Promise.resolve();
      if (!window.__hcSplidePromise) {
        window.__hcSplidePromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
          script.async = true;
          script.onload = resolve;
          script.onerror = resolve;
          document.head.appendChild(script);
        });
      }
      return window.__hcSplidePromise;
    }
  }
  if (!customElements.get('splide-component')) customElements.define('splide-component', SplideComponent);
})();
